import React from 'react';

import * as styles from './BeefSammy.module.scss';

export default function BeefSammy({ open, onClick }) {
  return (
    <button
      className={[styles.beefSammy, open ? styles.open : ''].join(' ')}
      onClick={onClick}
      type="button"
      aria-label="Open and close navigation menu"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48">
        <path d="M2 16H45" stroke="black" strokeWidth="2" className={styles.top} />
        <path d="M2 32H45" stroke="black" strokeWidth="2" className={styles.bottom} />
      </svg>
    </button>
  );
}
